export const footerText = `
Our major goal is to help individuals build a promising financial future, through our various products and services
`;

export const address = `
Suite 34, Gods Own Plaza, 4 Takum Close Area 11, Garki II, FCT,  Abuja
`;

export const addressAlt = `
495, Fagalawa Jaba, Airport Road, Kano State
`;

export const companyEmail = 'brownconinvestmentlimited@gmail.com';

export const companyPhone = '+2348038100785';

export const companyPhoneAlt = '+2348133580178';

export const socialLinks = {
  facebook: 'https://www.facebook.com/brownconinvestment',
  instagram: 'https://www.instagram.com/p/B6U-p_ylrmY',
};

const externalLink = 'https://brownconinvestment.com';

export const routes = {
  home: {
    pathname: '/',
  },
  about: {
    pathname: '/',
    hash: '#about',
  },
  packages: {
    pathname: '/',
    hash: '#packages',
  },
  investment: {
    pathname: '/investment',
  },
  faq: {
    pathname: '/faq',
  },
  team: {
    pathname: '/team',
  },
  blog: {
    pathname: '/blog',
  },
  blogDetails: {
    pathname: '/blog-details',
  },
  contact: {
    pathname: '/contact',
  },
  join: {
    pathname: '/join',
  },
  register: {
    pathname: '/register',
  },
  login: {
    pathname: '/login',
  },
  dashboard: {
    pathname: '/dashboard',
  },
  changePassword: {
    pathname: '/change-password',
  },
  external: {
    home: externalLink,
    about: `${externalLink}/about`,
    services: `${externalLink}/our-services`,
    contact: `${externalLink}/contact-us`,
  },
};
